import styled from 'styled-components';
import bg from '../../assets/images/bank_left_bg.png';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 40px;
	background-image: url(${bg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	border-right: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledPanelControlsContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 20px;
`;

const StyledTopContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 40px;
`;

const StyledButtonContent = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	gap: 20px;
	padding-left: 2px;

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
	}
`;

export {
	StyledButtonContent,
	StyledContainer,
	StyledPanelControlsContainer,
	StyledTopContainer,
};
